import { Button, ChevronDownSVG } from "@newsela/angelou";
import PropTypes from "prop-types";

import { withTrackEvent, objectTypes, actionNames } from "@newsela/snitch";
import useCurrentArticleLevelId from "@/view/utils/useCurrentArticleLevelId";
import {
  nameAndExpandContainerCss,
  nameHeadingCss,
  chevronIconCss,
  textCss,
  numberOfCommentsCss,
  replyAndChevronCss,
} from "./AnnotationText.style";

const propTypes = {
  setIsExpanded: PropTypes.func,
  isExpanded: PropTypes.bool,
  text: PropTypes.string,
  firstName: PropTypes.string,
  lastName: PropTypes.string,
  numberOfCommentsInThread: PropTypes.number,
  isStudent: PropTypes.bool,
};

const ButtonWithTrackEvent = withTrackEvent(Button);

const AnnotationText = ({
  setIsExpanded,
  isExpanded,
  text,
  firstName,
  lastName,
  numberOfCommentsInThread,
  isStudent,
}) => {
  const levelId = useCurrentArticleLevelId();

  const replyCopy = `${numberOfCommentsInThread} ${numberOfCommentsInThread === 1 ? "reply" : "replies"}`;

  const eventProperties = {
    objectType: objectTypes.annotation,
    actionName: isExpanded ? actionNames.hide : actionNames.read,
    streamProperties: {
      content_type: "Article",
      description: `${isExpanded ? "Hide" : "Display"} annotation`,
      content_id: levelId,
      // TODO: Currently, we don't have the annotation's id. Add `object_id` property with the right value for this event
    },
  };

  return (
    <div>
      <div css={nameAndExpandContainerCss}>
        <h3 css={nameHeadingCss}>{`${firstName.charAt(0)}. ${lastName}`}</h3>
        <div css={replyAndChevronCss}>
          {numberOfCommentsInThread > 0 && isStudent ? (
            <span css={numberOfCommentsCss}>{replyCopy}</span>
          ) : null}
          <ButtonWithTrackEvent
            onClick={() => {
              setIsExpanded(!isExpanded);
            }}
            icon={{
              SvgComponent: ChevronDownSVG,
            }}
            __cssFor={{
              Icon: { root: chevronIconCss(isExpanded) },
            }}
            flavor={Button.flavors.incognito}
            ariaProps={{
              "aria-label": "annotation text",
              "aria-expanded": isExpanded,
            }}
            {...eventProperties}
          />
        </div>
      </div>
      {isExpanded && <div css={textCss}>{text}</div>}
    </div>
  );
};

AnnotationText.propTypes = propTypes;

export default AnnotationText;
